import { render } from "./Faq.vue?vue&type=template&id=14899d05&scoped=true&ts=true"
import script from "./Faq.ts?vue&type=script&lang=ts&external"
export * from "./Faq.ts?vue&type=script&lang=ts&external"

import "./Faq.scss?vue&type=style&index=0&id=14899d05&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14899d05"]])

export default __exports__